import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  name: "",
  email: "",
  subject: "",
  message: "",
};

const newUserSlice = createSlice({
  name: "newUser",
  initialState,
  reducers: {
    updateName(state, action) {
      state.name = action.payload;
    },
    updateEmail(state, action) {
      state.email = action.payload;
    },
    updateSubject(state, action) {
      state.subject = action.payload;
    },
    updateMessage(state, action) {
      state.message = action.payload;
    },
    resetNewUser(state, action) {
      return initialState;
    },
  },
});

export const {
  updateName,
  updateEmail,
  updateSubject,
  updateMessage,
  resetNewUser,
} = newUserSlice.actions;
export default newUserSlice.reducer;
